import { FacilityIdFormErrorJSON } from '../models/facility-id-form';

export const formFacilityIdErrors: FacilityIdFormErrorJSON = {
    paidToFacilityId: [
        {
            code: 'required',
            message: 'This field is required',
        },
    ],
};
